"use client";

import { usePathname } from "next/navigation";
import Header from "./(routes)/(Home)/(sections)/Header";
import Footer from "./(routes)/(Home)/(sections)/FooterSection";

export default function LayoutWrapper({ children }) {
  const pathname = usePathname();

  // Hide header/footer for admin, member dashboard, and standalone pages
  const hideHeaderFooter = 
    pathname === "/invite" ||
    pathname?.startsWith("/admin") ||
    pathname?.startsWith("/dashboard") ||
    pathname === "/ecosystem" ||
    pathname === "/membership" ||
    pathname === "/apply" ||
    pathname === "/investors" ||
    pathname === "/mentors" ||
    pathname === "/content-library";

  return (
    <>
      {!hideHeaderFooter && <Header />}
      {children}
      {!hideHeaderFooter && <Footer />}
    </>
  );
}
